var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcontrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 3.99992H15.1673V5.33325H13.834V13.9999C13.834 14.3681 13.5355 14.6666 13.1673 14.6666H3.83398C3.4658 14.6666 3.16732 14.3681 3.16732 13.9999V5.33325H1.83398V3.99992H5.16732V1.99992C5.16732 1.63173 5.4658 1.33325 5.83398 1.33325H11.1673C11.5355 1.33325 11.834 1.63173 11.834 1.99992V3.99992ZM12.5007 5.33325H4.50065V13.3333H12.5007V5.33325ZM6.50065 7.33325H7.83398V11.3333H6.50065V7.33325ZM9.16732 7.33325H10.5007V11.3333H9.16732V7.33325ZM6.50065 2.66659V3.99992H10.5007V2.66659H6.50065Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontrash);
export default __webpack_public_path__ + "static/media/icon.trash.fdf7169843ef06e7b5ad6f28698ebd09.svg";
export { ForwardRef as ReactComponent };